class TasacionesRecovery extends TasacionesFunnelManager {
    constructor() {
        super({
            stepNumber: 'recovery',
            checkoutUrl: TasacionesConf.checkout_url || '/checkout',
            thanksUrl: TasacionesConf.thanks_url || '/thanks'
        });

        this.allowedMime = ['application/pdf'];
        this.pendingUploads = 0;

        this.initRecoveryElements();
        this.bindEvents();
        this.initState();
    }

    validateEnvironment() {
        return !!document.getElementById('tasaciones-recovery-form') && typeof TasacionesConf !== 'undefined';
    }

    initRecoveryElements() {
        this.elements = {
            form: document.getElementById('tasaciones-recovery-form'),
            submitBtn: document.getElementById('submit-btn-step-3'),
            priceElement: document.getElementById('tasaciones_funnel_price')
        };

        if (!this.elements.form) {
            return;
        }
        this.ajaxUrl = (window.TasacionesConf && TasacionesConf.ajax_url) || '';

        const maxUploadMb = parseInt((window.TasacionesConf && TasacionesConf.upload_max_filesize) || '250', 10);
        this.maxUploadMb = Number.isFinite(maxUploadMb) ? maxUploadMb : 250;
        this.maxBytes = this.maxUploadMb * 1024 * 1024;
        this.filePlaceholder = `Seleccionar PDF ${this.maxUploadMb}MB max`;
        this.priceMap = this.parsePriceMap();

        this.orderId = this.elements.form.querySelector('input[name="order_id"]')?.value || '';
        this.token = this.elements.form.querySelector('input[name="token"]')?.value || '';
        this.signature = this.elements.form.querySelector('input[name="sig"]')?.value || '';
        this.clientHash = this.elements.form.querySelector('input[name="client_hash"]')?.value || '';
        this.agentHash = this.elements.form.querySelector('input[name="agent_hash"]')?.value || '';
        this.formNonce = this.elements.form.querySelector('input[name="tasaciones_recovery_form_nonce"]')?.value || '';
        this.buy = this.elements.form.querySelector('input[name="buy"]')?.value === '1';

        this.slots = [
            this.buildSlotConfig('vivienda', 'tiene_nota_simple', 'nota_simple_container', 'nota_simple'),
            this.buildSlotConfig('garaje', 'tiene_nota_simple_garaje', 'tiene_nota_simple_garaje_container', 'nota_simple_garaje'),
            this.buildSlotConfig('trastero', 'tiene_nota_simple_trastero', 'tiene_nota_simple_trastero_container', 'nota_simple_trastero')
        ].filter(Boolean);
    }

    parsePriceMap() {
        const input = document.getElementById('tasaciones_recovery_price_map');
        if (!input || !input.value) {
            return {};
        }

        try {
            return JSON.parse(input.value);
        } catch (error) {
            return {};
        }
    }

    buildSlotConfig(key, radioName, containerId, hiddenId) {
        const radios = Array.from(document.querySelectorAll(`input[name="${radioName}"]`));
        const hidden = document.getElementById(hiddenId);
        const text = document.getElementById(`${hiddenId}_text`);
        const fileInput = document.getElementById(`${hiddenId}_file`);
        const selectButton = document.getElementById(`select_${hiddenId}`);
        const removeButton = document.getElementById(`remove_${hiddenId}`);
        const wrapper = document.querySelector(`.file-wrapper[data-hidden-id="${hiddenId}"]`);

        if (!radios.length || !hidden || !text || !fileInput || !selectButton || !removeButton || !wrapper) {
            return null;
        }

        return {
            key,
            radioName,
            hiddenId,
            radios,
            hidden,
            text,
            fileInput,
            selectButton,
            removeButton,
            container: document.getElementById(containerId),
            wrapper
        };
    }

    bindEvents() {
        if (!this.elements.form) {
            return;
        }

        this.elements.form.addEventListener('submit', (event) => this.handleFormSubmit(event));

        this.slots.forEach((slot) => {
            slot.selectButton.addEventListener('click', () => slot.fileInput.click());
            slot.fileInput.addEventListener('change', () => this.handleFileSelection(slot));
            slot.removeButton.addEventListener('click', () => {
                this.removeUploadedFile(slot);
            });

            slot.radios.forEach((radio) => {
                radio.addEventListener('change', () => this.handleChoiceChange(slot));
            });
        });
    }

    initState() {
        this.slots.forEach((slot) => {
            this.ensureDefaultChoice(slot);
            this.syncLoadedState(slot);
            this.updateSlotVisibility(slot);
        });
        this.updatePrice();
        this.updateSubmitButtonLabel();
    }

    ensureDefaultChoice(slot) {
        if (!slot || this.getSelectedChoice(slot)) {
            return;
        }

        const defaultChoice = this.buy ? 'la paga' : 'si';
        const defaultRadio = slot.radios.find((radio) => radio.value === defaultChoice);
        if (defaultRadio) {
            defaultRadio.checked = true;
        }
    }

    handleFileSelection(slot) {
        const file = slot.fileInput.files && slot.fileInput.files[0] ? slot.fileInput.files[0] : null;

        if (!file) {
            this.syncLoadedState(slot);
            this.resetButton(slot.selectButton);
            return;
        }

        const validation = this.validateFile(file);
        if (!validation.ok) {
            slot.hidden.value = '';
            slot.fileInput.value = '';
            this.syncLoadedState(slot);
            this.resetButton(slot.selectButton);
            this.showError(validation.error);
            return;
        }

        slot.text.value = file.name;
        this.uploadFile(slot, file);
        slot.fileInput.value = '';
    }

    handleChoiceChange(slot) {
        this.updateSlotVisibility(slot);

        if (this.getSelectedChoice(slot) !== 'si') {
            this.removeUploadedFile(slot, true).finally(() => {
                this.syncLoadedState(slot);
                this.resetButton(slot.selectButton);
            });
        }

        this.updatePrice();
        this.updateSubmitButtonLabel();
    }

    handleFormSubmit(event) {
        if (this.pendingUploads > 0) {
            this.setResponse('error', 'Espera a que terminen las subidas en curso.');
            event.preventDefault();
            return false;
        }

        const error = this.validateBeforeSubmit();
        if (error) {
            this.showError(error);
            event.preventDefault();
            return false;
        }

        this.setFormDisabled(true);
        this.showLoading(true);
        return true;
    }

    validateFile(file) {
        if (!file) {
            return { ok: false, error: 'Archivo no seleccionado.' };
        }

        if (file.size > this.maxBytes) {
            return { ok: false, error: `El archivo no puede superar los ${this.maxUploadMb}MB.` };
        }

        if (!this.allowedMime.includes(file.type)) {
            return { ok: false, error: 'Solo puede adjuntar archivos PDF.' };
        }

        return { ok: true };
    }

    uploadFile(slot, file) {
        if (!this.ajaxUrl) {
            this.setResponse('error', 'Sin URL AJAX.');
            return;
        }

        this.pendingUploads++;
        this.setFormDisabled(true);
        this.showLoading(true);
        this.setUploading(slot.selectButton);

        const formData = new FormData();
        formData.append('action', 'tasaciones_recovery_upload_file');
        formData.append('order_id', this.orderId);
        formData.append('token', this.token);
        formData.append('sig', this.signature);
        formData.append('client_hash', this.clientHash);
        formData.append('agent_hash', this.agentHash);
        formData.append('campo', slot.key);
        formData.append('file', file);

        fetch(this.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
            .then((response) => response.json().catch(() => ({})))
            .then((json) => {
                if (!json || !json.success) {
                    throw new Error(json?.data?.message || json?.message || 'Error enviando el archivo.');
                }

                slot.hidden.value = json.data?.file_name || '';
                this.syncLoadedState(slot);
                this.markUploadOk(slot.selectButton);
            })
            .catch((error) => {
                slot.hidden.value = '';
                this.syncLoadedState(slot);
                this.resetButton(slot.selectButton);
                this.showError(error.message || 'No se ha podido subir el archivo.');
            })
            .finally(() => {
                this.pendingUploads--;
                if (this.pendingUploads === 0) {
                    this.setFormDisabled(false);
                    this.showLoading(false);
                }
            });
    }

    removeUploadedFile(slot, silentIfEmpty = false) {
        if (!slot || !slot.hidden) {
            return Promise.resolve();
        }

        const existing = slot.hidden.value;
        if (!existing) {
            slot.fileInput.value = '';
            if (!silentIfEmpty) {
                this.syncLoadedState(slot);
                this.resetButton(slot.selectButton);
            }
            return Promise.resolve();
        }

        const formData = new FormData();
        formData.append('action', 'tasaciones_recovery_delete_file');
        formData.append('order_id', this.orderId);
        formData.append('token', this.token);
        formData.append('sig', this.signature);
        formData.append('client_hash', this.clientHash);
        formData.append('agent_hash', this.agentHash);
        formData.append('campo', slot.key);
        formData.append('file_path', existing);

        this.setDeleting(slot.selectButton);

        return fetch(this.ajaxUrl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
            .then((response) => response.json().catch(() => ({})))
            .then((json) => {
                if (!json || !json.success) {
                    throw new Error(json?.data?.message || json?.message || 'Error al borrar.');
                }

                slot.hidden.value = '';
                slot.fileInput.value = '';
                this.syncLoadedState(slot);
                this.resetButton(slot.selectButton);
            })
            .catch((error) => {
                this.markUploadOk(slot.selectButton);
                if (!silentIfEmpty) {
                    this.showError(error.message || 'No se ha podido borrar el archivo.');
                }
            });
    }

    validateBeforeSubmit() {
        for (const slot of this.slots) {
            if (this.getSelectedChoice(slot) === 'si' && !slot.hidden.value) {
                return 'Debes adjuntar un PDF antes de enviar la documentación.';
            }
        }

        return '';
    }

    getSelectedChoice(slot) {
        const selected = slot.radios.find((radio) => radio.checked);
        return selected ? selected.value : '';
    }

    updatePrice() {
        if (!this.elements.priceElement) {
            return;
        }

        let total = 0;

        this.slots.forEach((slot) => {
            if (this.getSelectedChoice(slot) === 'la paga') {
                total += Number(this.priceMap?.[slot.key]?.amount || 0);
            }
        });

        this.elements.priceElement.innerText = this.formatCurrency(total);

        if (total > 0) {
            this.elements.priceElement.classList.remove('tasaciones-hidden');
        } else {
            this.elements.priceElement.classList.add('tasaciones-hidden');
        }
    }

    updateSubmitButtonLabel() {
        if (!this.elements.submitBtn) {
            return;
        }

        const selectedChoices = this.slots
            .map((slot) => this.getSelectedChoice(slot))
            .filter((choice) => choice === 'si' || choice === 'la paga');

        const hasPaySlots = selectedChoices.includes('la paga');
        const hasUploadSlots = selectedChoices.includes('si');

        if (hasPaySlots && hasUploadSlots) {
            this.elements.submitBtn.innerText = 'Enviar y pagar';
            return;
        }

        if (hasPaySlots) {
            this.elements.submitBtn.innerText = 'Pagar';
            return;
        }

        this.elements.submitBtn.innerText = 'Enviar';
    }

    formatCurrency(amount) {
        return new Intl.NumberFormat('es-ES', {
            style: 'currency',
            currency: 'EUR'
        }).format(Number(amount || 0));
    }

    updateSlotVisibility(slot) {
        if (!slot.container) {
            return;
        }

        slot.container.classList.toggle('tasaciones-hidden', this.getSelectedChoice(slot) !== 'si');
    }

    syncLoadedState(slot) {
        const currentValue = slot.hidden.value || '';
        const currentText = slot.text.dataset.file || '';

        if (currentValue) {
            slot.text.value = currentText || currentValue.split('/').pop();
            slot.wrapper.classList.add('has-file');
            this.markUploadOk(slot.selectButton);
            return;
        }

        slot.text.value = this.filePlaceholder;
        slot.wrapper.classList.remove('has-file');
        this.resetButton(slot.selectButton);
    }

    setFormDisabled(disabled) {
        if (!this.elements.form) {
            return;
        }

        this.elements.form.querySelectorAll('[type="submit"]').forEach((button) => {
            button.disabled = disabled;
        });
    }

    setUploading(button) {
        if (!button) {
            return;
        }

        const label = button.querySelector('span');
        if (label) {
            label.innerText = 'Subiendo...';
        }

        button.classList.remove('ok', 'error', 'deleted');
        button.classList.add('uploading');
    }

    setDeleting(button) {
        if (!button) {
            return;
        }

        const label = button.querySelector('span');
        if (label) {
            label.innerText = 'Borrando...';
        }

        button.classList.remove('ok', 'error');
        button.classList.add('deleting');
    }

    markUploadOk(button) {
        if (!button) {
            return;
        }

        button.classList.remove('uploading', 'error', 'deleting');
    }

    resetButton(button) {
        if (!button) {
            return;
        }

        const label = button.querySelector('span');
        if (label) {
            label.innerText = 'Adjuntar';
        }

        button.classList.remove('uploading', 'ok', 'error', 'deleting');
    }

    showError(message) {
        super.showError(message);
        window.alert(message);
    }
}

window.TasacionesRecovery = TasacionesRecovery;
